import React from 'react';
import { Link } from 'react-router-dom';

export default function Logo({ size = 'md', to = '/' }) {
  return (
    <Link to={to} className={`brand-logo ${size === 'lg' ? 'brand-logo-lg' : ''}`} aria-label="Cursive Text Generator" data-testid="site-logo">
      <svg className="brand-mark" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <rect width="64" height="64" rx="20" fill="currentColor" />
        <path d="M45 20C42 10 27 15 20 28C10 47 24 54 39 43C48 37 51 34 54 37" stroke="#fffaf4" strokeWidth="3.2" strokeLinecap="round" />
        <path d="M42 19C30 17 25 31 30 34C35 37 44 27 42 19Z" stroke="#fffaf4" strokeWidth="2" strokeLinecap="round" />
        <circle cx="48" cy="49" r="2.5" fill="#dabec8" />
      </svg>
      <span className="brand-wordmark">
        <span className="brand-name">Cursive</span>
        <span className="brand-descriptor">Text Generator</span>
      </span>
    </Link>
  );
}
